export default () => ({
  countries: [],
  paymentMethods: [],
  shippingMethods: [],
  country: {},
  shippingMethod: {},
  paymentMethod: {},
});
